import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import config from './config'
import de from 'element-ui/src/locale/lang/de'
Vue.use(Vuex)

const storeDescription = new Vuex.Store({
  state: {
    count: 0,
    is_logged_in: false,
    jwt_access_token: null,
    jwt_refresh_token: null,
    sign_up_error: '',
    sign_in_error: '',
    profile: null,
  },
  mutations: {
    increment (state) {
      state.count++
    },
    set_sign_up_error (state, payload) {
      state.sign_up_error = payload
    },
    set_sign_in_error (state, payload) {
      state.sign_in_error = payload
    },
    perform_logout (state, payload) {
      state.jwt_access_token = null
      state.jwt_refresh_token = null
      localStorage.removeItem('jwt_access_token')
      localStorage.removeItem('jwt_refresh_token')
      state.is_logged_in = false

    },
    did_receive_jwt_tokens (state, payload) {
      state.jwt_access_token = payload.access
      localStorage.jwt_access_token = state.jwt_access_token

      if (payload.refresh){
        state.jwt_refresh_token = payload.refresh
        localStorage.jwt_refresh_token = payload.refresh
      }

      state.is_logged_in = true
    },
    did_load_profile (state, payload) {
      state.profile = payload
    }

  },
  actions: {
    async cancelSubscription(context, payload) {
      let response = await axios.post(config.api_root + '/api/cancel-subscription', {})
      await context.dispatch('willLoadProfile', {})
    },
    async init(context, payload) {
      if (localStorage.jwt_refresh_token) {
        try {
          let response = await axios.post(config.api_root + '/api/token/refresh/', {refresh: localStorage.jwt_refresh_token})
          context.commit('did_receive_jwt_tokens', response.data)

        }
        catch (e) {
          if (e.response) {
            console.log(e.response)
          }
        }
      }
    },
    logout(context, payload) {
      context.commit('perform_logout', {})
    },
    async willLoadProfile(context, payload) {
      let response = await axios.get(config.api_root + '/api/my-profile',
        {
          // headers: {Authorization: 'Bearer ' + localStorage.jwt_access_token}
        })
      context.commit('did_load_profile', response.data)

    },
    track_event(context, payload) {

    },
    async willSignIn(context, payload) {
      context.commit('set_sign_in_error', '')
      try {
        let response = await axios.post(config.api_root + '/api/sign-in', {email: payload.email, password: payload.password})
        context.commit('did_receive_jwt_tokens', response.data)

      } catch (error) {
        console.log(Object.keys(error), error.message);
        if (error.response) {
          console.log(error.response)
          if (error.response.status == 403) {
            context.commit('set_sign_in_error', error.response.data.cause)
          }
        }
        console.error(error)
      }
    },
    async willRegister(context, payload) {
      console.log('A?')
      console.log(payload)
      context.commit('set_sign_up_error', '')

      context.commit('increment')

      let response
      try {
        response = await axios.post(config.api_root + '/api/sign-up', {email: payload.email, password: payload.password})
        context.commit('did_receive_jwt_tokens', response.data)

      } catch (error) {
        console.log(Object.keys(error), error.message);
        if (error.response) {
          console.log(error.response)
          if (error.response.status == 412) {
            context.commit('set_sign_up_error', error.response.data.cause)
          }
        }
        console.error(error)
      }
    }
  }
})


export default storeDescription